/**
 * SHA-256 of a file as lowercase hex, for `POST /v1/imports`'s `contentSha256`.
 *
 * Web Crypto has no streaming digest, so the whole file is read into memory. A full
 * 50,000-row file is 18.4 MB (`designs/Screen · Spreadsheet Import.dc.html:59`) and the
 * 200 MB cap is the outer bound. An incremental hash is a new dependency — Cameron's call.
 */
export async function sha256Hex(file: Blob): Promise<string> {
  const digest = await crypto.subtle.digest("SHA-256", await file.arrayBuffer());
  return [...new Uint8Array(digest)].map((b) => b.toString(16).padStart(2, "0")).join("");
}
